import { EnterpriseSearchService, ServiceType } from '@sabstravtech/obtservices/angular';
import { IRLEnterpriseSearchInterface } from '@sabstravtech/obtservices/base';
import { Component, Input } from '@angular/core';

import { ProductLoadingScreen } from './product-loading-screen';

@Component({
  selector: 'app-irl-loading-screen',
  templateUrl: './irl-loading-screen.component.html',
  styleUrls: [],
  standalone: false
})
export class IRLLoadingScreenComponent extends ProductLoadingScreen<IRLEnterpriseSearchInterface> {
  @Input() animated = true;
  constructor(service: EnterpriseSearchService) {
    super(service, service.searches[ServiceType.InternationalRail]);
  }
}
